export const imageToBase64 = async (
  imagePath: string,
  isFullPath = false,
): Promise<string> => {
  return new Promise(async (resolve) => {
    let _url = `${
      process.env.PUBLIC_ASSETS_URL || process.env.STORYBOOK_PUBLIC_ASSETS_URL
    }/solution-advisor/${imagePath}`;
    if (isFullPath) _url = imagePath;
    const response = await fetch(_url);
    const imageBlob = await response.blob();

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result as string;
      if (base64) resolve(base64);
    };

    reader.readAsDataURL(imageBlob);
  });
};

export const SOLUTION_HEADER = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};

// preparing the solution advisory config json based on environment
export const prepareProductsUrl = () => {
  const environment = window.location.host;
  if (environment === 'www.ibm.com') {
    return `https://ace-project-bucket.s3.us-east.cloud-object-storage.appdomain.cloud/production/solution-advisor/solutionAdvisorProducts.json`;
  } else {
    return `https://ace-project-bucket.s3.us-east.cloud-object-storage.appdomain.cloud/test/solution-advisor/solutionAdvisorProducts.json`;
  }
};

export const postMailSubmission = async (obj: object) => {
  try {
    const _url = `https://sdp-api.cloud-platform.ibm.com/flashsystem/pricing/api/contact`;
    const body = JSON.stringify(obj);
    const response = await fetch(_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    });

    if (!response.ok) {
      console.error('Failed to fetch script URL:', response.status);
    }
  } catch (error) {
    console.error('Error during API request:', error);
  }
};
